import { render, staticRenderFns } from "./TableRiskAppraisalEp2.vue?vue&type=template&id=04153f6b&scoped=true"
import script from "./TableRiskAppraisalEp2.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisalEp2.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisalEp2.vue?vue&type=style&index=0&id=04153f6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04153f6b",
  null
  
)

export default component.exports